import { Action, createAction, handleActions } from "redux-actions";
import { GetPolizaMultiramaResponse } from "~api/types";
import { Dispatch, GetState, Services } from "../types";

interface DetallePolizaMultiramaState {
  isLoading: boolean;
  currentPoliza: GetPolizaMultiramaResponse | null;
  failed: boolean;
}

const getPolizaInited = createAction("OBTENER_POLIZA_MULTI_INITED");

const getPolizaCompleted = createAction(
  "OBTENER_POLIZA_MULTI_COMPLETED",
  (currentPoliza: GetPolizaMultiramaResponse) => ({ currentPoliza })
);

const getPolizaFailed = createAction(
  "OBTENER_POLIZA_MULTI_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getPoliza = (id: string) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(getPolizaInited());

      const response = await services.api
        .polizasMultirama()
        .getPolizaMultirama(id);

      dispatch(getPolizaCompleted(response));
    } catch (error) {
      console.log(error);
      dispatch(getPolizaFailed(error));
    }
  };
};

const clearData = createAction("CLEAR_DATA_MULTIRAMA", () => ({}));

const detallePolizaMultiramaReducerInitialState: DetallePolizaMultiramaState = {
  isLoading: false,
  currentPoliza: null,
  failed: false,
};

const detallePolizaMultiramaReducer = handleActions<
  DetallePolizaMultiramaState,
  any
>(
  {
    [clearData.toString()]: (): DetallePolizaMultiramaState => {
      return {
        ...detallePolizaMultiramaReducerInitialState,
      };
    },
    [getPolizaInited.toString()]: (): DetallePolizaMultiramaState => {
      return {
        ...detallePolizaMultiramaReducerInitialState,
        isLoading: true,
      };
    },
    [getPolizaCompleted.toString()]: (
      state: DetallePolizaMultiramaState,
      action: Action<{ currentPoliza: GetPolizaMultiramaResponse }>
    ): DetallePolizaMultiramaState => {
      return {
        ...state,
        currentPoliza: action.payload.currentPoliza,
        isLoading: false,
        failed: false,
      };
    },
    [getPolizaFailed.toString()]: (
      state: DetallePolizaMultiramaState
    ): DetallePolizaMultiramaState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
  },
  detallePolizaMultiramaReducerInitialState
);

export { detallePolizaMultiramaReducer };

export { getPoliza, clearData };
